<ng-container ngForm="ewPPInputForm">
	<div vbUiRadioBtnGroup [attr.aria-label]="'PresentationProfile' | translate">
		<button type="button" class="btn btn-white" name="profileFilterAll" [(ngModel)]="filterAvailable" (ngModelChange)="onFilterChange()" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
			{{ 'Event_All' | translate }}
		</button>
		<button type="button" class="btn btn-white" name="profileFilterAvailable" [(ngModel)]="filterAvailable" (ngModelChange)="onFilterChange()" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
			{{ 'Event_Available' | translate }}
		</button>
	</div>
	<presentation-profile-picker-table *ngIf="presentationProfiles?.length" [displayedRows]="6" [webcastId]="webcastId" [value]="value" [presentationProfiles]="presentationProfiles" [getStartDate]="getStartDateCallback" (presentationProfileSelected)="onProfileSelected($event)"></presentation-profile-picker-table>
</ng-container>
